module.exports = Promise.all([__parcel__import__("tV1up"), __parcel__import__("7JGx7")]).then(() => parcelRequire('g36Vt'));